/** 섹션을 떠나도 모듈이 보존하는 Dataset별 episode 세션을 얻는다. */
import { acquireInspectSession, type InspectSession } from "../feature/inspectSession";

export function useInspectSession(
  probeUuid: string,
  sourceId: string,
  datasetUuid?: string,
): InspectSession {
  return acquireInspectSession({ probeUuid, sourceId, datasetUuid });
}
